var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndeterminateCheckBoxFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.556 13.111h8.888q.473 0 .792-.32.32-.318.32-.791t-.32-.792a1.08 1.08 0 0 0-.792-.32H7.556q-.473 0-.792.32t-.32.792.32.792.792.32M4.222 22a2.14 2.14 0 0 1-1.57-.653A2.14 2.14 0 0 1 2 19.777V4.223q0-.915.653-1.57A2.14 2.14 0 0 1 4.223 2h15.555a2.14 2.14 0 0 1 1.57.653q.652.652.652 1.57v15.555a2.14 2.14 0 0 1-.653 1.57 2.14 2.14 0 0 1-1.57.652z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndeterminateCheckBoxFill);
export default __webpack_public_path__ + "static/media/indeterminate_check_box_fill.1330cdf7074987dd6fa9464a180a7076.svg";
export { ForwardRef as ReactComponent };